<template>
  <div class="risk-detail-page">
    <section class="detail-card overview-card">
      <h3 class="detail-title">人员风控总览</h3>
      <div class="overview-grid">
        <div class="overview-item">
          <span class="label">客户名称</span>
          <span class="value">{{ row.sourceTypeName || '暂无' }}</span>
        </div>
        <div class="overview-item">
          <span class="label">人员姓名</span>
          <span class="value">{{ row.payeeName || '暂无' }}</span>
        </div>
        <div class="overview-item">
          <span class="label">身份证号</span>
          <span class="value">{{ row.idCard || '暂无' }}</span>
        </div>
        <div class="overview-item">
          <span class="label">绑定用户数 / 预警阈值</span>
          <span class="value emphasis">{{ countThresholdText(row.bindUserCount, row.alarmNum) }}</span>
        </div>
        <div class="overview-item">
          <span class="label">风险状态</span>
          <span class="value">{{ getDictValue(row.riskStatus, 'risk_status') }}</span>
        </div>
        <div class="overview-item">
          <span class="label">提现风控状态</span>
          <span class="value">{{ getDictValue(row.cashRiskStatus, 'cash_risk_status') }}</span>
        </div>
        <div class="overview-item">
          <span class="label">提现申请合计</span>
          <span class="value">{{ amountText(row.cashApplyNum, row.cashApplyAmount) }}</span>
        </div>
        <div class="overview-item">
          <span class="label">成功提现合计</span>
          <span class="value success">{{ amountText(row.cashPayNum, row.cashPayAmount) }}</span>
        </div>
        <div class="overview-item">
          <span class="label">风控拦截合计</span>
          <span class="value danger">{{ amountText(row.cashBlockNum, row.cashBlockAmount) }}</span>
        </div>
        <div class="overview-item">
          <span class="label">最近提现时间</span>
          <span class="value">{{ row.lastCashTime || '暂无' }}</span>
        </div>
      </div>
    </section>

    <section class="detail-card user-detail-card">
      <h3 class="detail-title">绑定用户明细</h3>
      <DetailList :propsObj="row" />
    </section>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import DetailList from './detail_list';

export default {
  name: 'RiskDetail',
  components: {
    DetailList,
  },
  props: {
    formConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    row() {
      return this.formConfig.row || {};
    },
  },
  data() {
    return {
      dictCodeList: {},
    };
  },
  created() {
    this.loadDicts();
  },
  methods: {
    loadDicts() {
      return request.post('/mdm/mdmdictdata/batchDictSelect', [
        'risk_status',
        'cash_risk_status',
      ]).then((res) => {
        if (res.success) {
          this.dictCodeList = res.result || {};
        }
      });
    },
    getDictValue(value, code) {
      if (value == null || value === '') return '暂无';
      const options = this.dictCodeList[code] || [];
      const item = options.find((option) => option.dictCode === `${value}`);
      return item ? item.dictValue : value;
    },
    amountText(count, amount) {
      if (count == null && amount == null) return '暂无';
      const countText = count == null ? 0 : count;
      const amountTextValue = amount == null ? 0 : amount;
      return `${countText}笔 / ¥${amountTextValue}`;
    },
    countThresholdText(count, threshold) {
      if (count == null && threshold == null) return '暂无';
      const countText = count == null ? 0 : count;
      return `${countText}个 / 阈值 ≥ ${threshold == null ? '暂无' : threshold}`;
    },
  },
};
</script>

<style lang="less" scoped>
.risk-detail-page {
  min-height: 100%;
  padding: 12px;
  background: #f5f7fa;
  box-sizing: border-box;
}

.detail-card {
  margin-bottom: 16px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .08);
}

.detail-title {
  display: flex;
  align-items: center;
  margin: 0 0 18px;
  color: #202938;
  font-size: 16px;
  line-height: 20px;
}

.detail-title::before {
  flex: 0 0 5px;
  width: 5px;
  height: 20px;
  margin-right: 10px;
  border-radius: 2px;
  background: #d52b2b;
  content: '';
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 22px 36px;
}

.overview-item {
  min-width: 0;
}

.label,
.value {
  display: block;
}

.label {
  margin-bottom: 7px;
  color: #9aa4b2;
  font-size: 13px;
}

.value {
  overflow: hidden;
  color: #364152;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.emphasis {
  color: #f04b4b;
}

.success {
  color: #10a477;
}

.danger {
  color: #f04b4b;
}

.user-detail-card {
  padding-bottom: 12px;
}

.user-detail-card /deep/ .page-pageination {
  margin-top: 28px;
}

@media (max-width: 1200px) {
  .overview-grid {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }
}
</style>
